import React from 'react';
import SvgInline from '@latitude/svg-inline';
import { Typography } from '@latitude/typography';
import {
  StyledProofPointContainer,
  StyledProofPointContentContainer,
  StyledProofPointTextContainer
} from './ProofPointStackedRebrand.styled';

const ProofPointStackedRebrand = ({
  point,
  trackingId,
  numOfPoints = 3,
  ...rest
}) => {
  const COMPONENT_ID = 'proof-point-stacked-rebrand';
  const componentIdentifier = trackingId
    ? `${trackingId}-${COMPONENT_ID}`
    : COMPONENT_ID;

  return (
    <StyledProofPointContainer
      numOfPoints={numOfPoints}
      className={componentIdentifier}
      {...rest}
    >
      <StyledProofPointContentContainer className={`${componentIdentifier}-content-container`}>
        {point?.icon && (
          <SvgInline
            className={`${componentIdentifier}-svg`}
            name={point.icon}
          />
        )}

        <StyledProofPointTextContainer className={`${componentIdentifier}-text-container`}>
          <Typography.SH3 semibold>
            {point?.title}
          </Typography.SH3>
          <Typography.Body>
            {point?.description}
          </Typography.Body>
        </StyledProofPointTextContainer>
      </StyledProofPointContentContainer>
    </StyledProofPointContainer>
  );
};

export default ProofPointStackedRebrand;
